export default "__VITE_ASSET__C$UIDii$__"